import { Link } from "react-router-dom";

export default function SiteFooter() {
  return (
    <footer className="w-full border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-950 font-label text-sm font-bold text-accent-400">
                HD
              </span>
              <span className="text-base font-bold tracking-tight text-foreground-950">诱人的女员工hd</span>
            </div>
            <p className="mt-4 text-sm leading-7 text-foreground-600">
              一个专注影视内容推荐与剧情解析的中文门户，用简洁的方式帮你快速了解一部作品值不值得看。
            </p>
          </div>

          <div>
            <h4 className="font-label text-xs uppercase tracking-[0.2em] text-foreground-500">快速导航</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {[
                { label: "首页", path: "/" },
                { label: "影视分类", path: "/category" },
                { label: "搜索结果", path: "/search" },
                { label: "关于我们", path: "/about" },
              ].map((item) => (
                <li key={item.path}>
                  <Link to={item.path} className="text-foreground-700 hover:text-accent-600 transition-colors cursor-pointer">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-label text-xs uppercase tracking-[0.2em] text-foreground-500">内容分类</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {["爱情", "悬疑", "治愈", "科幻", "文艺"].map((genre) => (
                <li key={genre}>
                  <Link
                    to={`/category?genre=${encodeURIComponent(genre)}`}
                    className="text-foreground-700 hover:text-accent-600 transition-colors cursor-pointer"
                  >
                    {genre}影视
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-label text-xs uppercase tracking-[0.2em] text-foreground-500">使用与声明</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/about#notice" className="text-foreground-700 hover:text-accent-600 transition-colors cursor-pointer">
                  使用须知
                </Link>
              </li>
              <li>
                <Link to="/about#privacy" className="text-foreground-700 hover:text-accent-600 transition-colors cursor-pointer">
                  隐私政策
                </Link>
              </li>
              <li>
                <Link to="/about#contact" className="text-foreground-700 hover:text-accent-600 transition-colors cursor-pointer">
                  联系我们
                </Link>
              </li>
            </ul>
            <p className="mt-5 text-xs leading-6 text-foreground-500">
              本站内容均为虚构演示资料，仅提供图文资讯，不提供播放与下载服务。
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 诱人的女员工hd影视专区 · 内容仅供影视资讯参考</p>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
            <span className="whitespace-nowrap">友情链接：影视资讯观察 / 剧情研究所 / 演员档案库</span>
          </div>
        </div>
      </div>
    </footer>
  );
}